/**
 * Confinement rules for scoped (limited) portal admins — currently the
 * recognition-only admin (backend role recognition_admin, JWT claim
 * scp: ['recognition']). Mirrors the onboarding-client gate in Router.js:
 * the per-route canAccessPortal guard admits them, and the global beforeEach
 * gate (plus the App.vue cold-load watcher) redirects anything outside the
 * allowed set back to /recognition. Pure module (no State import) so it stays
 * unit-testable — same pattern as utils/mfaGate.js.
 */

export const RECOGNITION_SCOPE = 'recognition';

// Recognition pages plus the auth/recovery flows and profile. 'profile' must
// stay reachable: the MFA-setup gate redirects there. 'not-found' must stay:
// route-guard failures land there, and confining it would loop when the
// company's recognition_version is 'off'.
export const SCOPED_ADMIN_ALLOWED_ROUTES = new Set([
  'recognition',
  'recognition-create-program',
  'recognition-create-open',
  'recognition-create-milestone',
  'recognition-settings',
  'recognition-award-detail',
  'login',
  'login-impersonate',
  'forgot-password',
  'reset-password',
  'profile',
  'not-found',
]);

export const isRecognitionOnlyClaims = claims => {
  if (!claims || claims.a || claims.m || claims.is || claims.oc) {
    return false;
  }
  return Array.isArray(claims.scp) && claims.scp.includes(RECOGNITION_SCOPE);
};

export const shouldConfineScopedAdmin = ({ claims, routeName }) =>
  isRecognitionOnlyClaims(claims) && !SCOPED_ADMIN_ALLOWED_ROUTES.has(routeName);
